#### Documentation updates

We’ve extended our documentation with new guidance:

- GraphQL usage

  We’ve documented some introductory concepts [specific to the SEEK API](/graphql/seek-api-conventions),
  along with general guidance for using GraphQL [in your software](/graphql/in-practice).
  This includes strong advice around using GraphQL variables to prevent code injection.

- [Reprocessing webhooks](/events/webhooks#duplicates)

  We’ve included advice on reprocessing “duplicate” webhooks.
  In the rare event of a data quality issue,
  this allows SEEK to perform remediation and prompt your software to automatically re-retrieve the affected objects.

- SEEK Application Export migration

  We’ve described a [new transition approach](/migration-guides/sae#method-1-deduplicating-applications) that allows you to run both integrations simultaneously and deduplicate applications rather than candidates.
  We’ve also noted some [common problems](/migration-guides/sae#common-problems).

We’ve refreshed our [schema documentation] site!
It should be easier to navigate and drill down into nested objects.

[schema documentation]: /schema
